export const SET = 'entities/setting/SET'
